const Data = [
  {
    id: 'Básico',
    name: 'Mono',
    quote_text: 'Apartamento Mono',
    price: '0',
    featureId: '',
  },
  {
    id: 'Liviano',
    name: 'Liviano',
    quote_text: 'Apartamento Liviano',
    price: '26,000,000',
    featureId: 'ed2f01b7-0a92-4e6d-903a-f08329bee5f8',
  },
]

module.exports = { Data };